// Owner identity check. Mirrors backend config.OWNER_USERNAME.
// Frontend check is UX-only — every backend admin endpoint re-verifies
// the username on the server. If these two strings ever drift, worst
// case is a user sees a "Dashboard" menu item but gets a 404 from the
// API; the admin surface itself remains inaccessible.
export const OWNER_USERNAME = 'sneakypanda42';

export const isOwner = (userInfo) =>
  !!userInfo?.username && userInfo.username.toLowerCase() === OWNER_USERNAME;
